import VueForm from '../../../scripts/VueFormSetup'
var Login = VueForm.FormSubmit('FormLogin',
    {
        UserName: '',
        Password: '',
        RememberMe: '',
        valid: '',
    },
    'ID')
Login.methods.complete = function (params) {
    if (params.status === 'success') {
        if (params.data.Status === 'Success') {
            this.reset()
            this.$root.$snackbar('Bienvenido ' + params.data.UserName + '!', { color: 'info' })
            this.$parent.$parent.$parent.isLoggedIn = true
            this.$parent.$parent.$parent.role = params.data.Role
            this.$parent.$parent.$parent.username = params.data.UserName
        } else if (params.data.Status === 'Failure') {
            this.$root.$snackbar('Su nombre de usuario y contraseña no coinciden con ninguna cuenta', { color: 'error' })
        } else if (params.data.Status === 'LockedOut') {
            this.$root.$snackbar('Tu cuenta esta bloqueada. Esto podría deberse a varias razones. Si cree que esto es un error, póngase en contacto con el equipo de soporte para obtener más información.', { color: 'error' })
        }
        else if (params.data.Status === 'RequiresVerification') {
            this.$root.$snackbar('Su cuenta requiere verificación de 2 factores.', { color: 'error' })
        }
        //Error
        else {
            this.$root.$snackbar('La solicitud se realizó con éxito, pero no pudimos determinar qué sucedió en esta solicitud. Si el error persiste, póngase en contacto con el equipo de soporte.', { color: 'error' })
        }
    } else {
        this.$root.$snackbar('No pudimos determinar qué sucedió en esta solicitud. Por favor, compruebe su conexión a Internet y vuelva a intentarlo. Si el error persiste, póngase en contacto con el equipo de soporte.', { color: 'error' })
        //instance.$parent.$parent.$parent.show = true
        //instance.$router.replace('/dashboard')
    }
}
export default Login


// WEBPACK FOOTER //
// ./src/components/account/login/script.js